import { createSelector } from 'reselect'
import { RootState } from 'constants/interfaces'

const notifications = (state: RootState) => state.notifications

export const unreadCountSelector = createSelector(notifications, ({ unreadCount }) => unreadCount)

export const notificationsInboxSelector = createSelector(notifications, ({ inbox }) => inbox)

export const notificationsUnreadSelector = createSelector(notifications, ({ unread }) => unread)
